// @flow

import * as React from 'react'
import { Stepper, Step, StepLabel, StepConnector } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  '@media (max-width: 992px)': {
    root: {
      '& .MuiStep-root:first-child': {
        display: 'flex',
        justifyContent: 'left',
        paddingLeft: 0,
        zIndex: 2,
      },
      '& .MuiStep-root:last-child': {
        display: 'flex',
        justifyContent: 'right',
        paddingRight: 0,
        '& .MuiStepConnector-root': {
          right: 'calc(23% + 20px)',
        },
      },
      '& .MuiStep-root:nth-child(2)': {
        '& .MuiStepConnector-root': {
          left: 'calc(-73% + 20px)',
        },
      },
    },
  },
  '@media (max-width: 498px)': {
    root: {
      '& .MuiStep-root:last-child': {
        '& .MuiStepConnector-root': {
          right: 'calc(29% + 20px)',
        },
      },
      '& .MuiStep-root:nth-child(2)': {
        '& .MuiStepConnector-root': {
          left: 'calc(-68% + 20px)',
        },
      },
    },
  },
  '@media (max-width: 408px)': {
    root: {
      '& .MuiStep-root:last-child': {
        '& .MuiStepConnector-root': {
          right: 'calc(36% + 20px)',
        },
      },
      '& .MuiStep-root:nth-child(2)': {
        '& .MuiStepConnector-root': {
          left: 'calc(-60% + 20px)',
        },
      },
    },
  },
  label: {
    fontSize: '14px',
  },
  disabled: {
    '& svg': {
      fill: '#DCE0E0',
      '& text': {
        fill: '#757575',
      },
    },
  },
})

const ColorLibConnector = withStyles({
  line: {
    borderColor: '#DCE0E0',
  },
})(StepConnector)

type StepperPropTypes = {| activeStep: number, steps: Array<string> |}

function CustomStepper({ activeStep, steps }: StepperPropTypes): React.Element<typeof Stepper> {
  const classes = useStyles()
  return (
    <Stepper
      className={classes.root}
      alternativeLabel
      activeStep={activeStep}
      connector={<ColorLibConnector />}
    >
      {steps.map((label, index) => (
        <Step key={`step${index}`}>
          <StepLabel classes={{ disabled: classes.disabled, label: classes.label }}>
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default CustomStepper
